// assets
import { IconBook2, IconCash, IconBuildingBank } from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

const icons = {
  IconLedgerMaster: IconBook2,
  IconLoan: IconCash,
  IconAccount: IconBuildingBank
};

// ==============================|| MENU ITEMS - LEDGER MASTER ||============================== //

const ledgerMaster: NavItemType = {
  id: 'ledger-master',
  title: 'Ledger Master',
  type: 'group',
  icon: icons.IconLedgerMaster,
  children: [
    {
      id: 'loan-ledger',
      title: 'Loan Ledger',
      type: 'item',
      url: '/ledger-master/loan-ledger',
      icon: icons.IconLoan,
      breadcrumbs: false
    },
    {
      id: 'account-ledger',
      title: 'Account Ledger',
      type: 'item',
      url: '/ledger-master/account-ledger',
      icon: icons.IconAccount,
      breadcrumbs: false
    }
  ]
};

export default ledgerMaster;